"use strict";
exports.__esModule = true;
exports.Sorting = exports.SortOrder = exports.FilterDocument = void 0;
var field_1 = require("../field");
var filter_1 = require("./filter");
var FilterDocument = /** @class */ (function () {
    function FilterDocument(id, name, entity_type, is_readonly, is_public, number_of_frozen_columns, sorting, fields, filter_groups, created_on, created_by, updated_on, updated_by, is_archived) {
        if (sorting === void 0) { sorting = [new Sorting(field_1.DefaultEntityFields.UPDATED_ON, SortOrder.DESC)]; }
        if (filter_groups === void 0) { filter_groups = new filter_1.FilterGroup(filter_1.LogicOperator.AND); }
        this.id = id;
        this.name = name;
        this.entity_type = entity_type;
        this.is_readonly = is_readonly;
        this.is_public = is_public;
        this.number_of_frozen_columns = number_of_frozen_columns;
        this.sorting = sorting;
        this.fields = fields;
        this.filter_groups = filter_groups;
        this.created_on = created_on;
        this.created_by = created_by;
        this.updated_on = updated_on;
        this.updated_by = updated_by;
        this.is_archived = is_archived;
    }
    FilterDocument.fromJSON = function (json) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        var doc = new FilterDocument((_a = json.id) !== null && _a !== void 0 ? _a : '', (_b = json.name) !== null && _b !== void 0 ? _b : '', (_c = json.entity_type) !== null && _c !== void 0 ? _c : null, (_d = json.is_readonly) !== null && _d !== void 0 ? _d : false, (_e = json.is_public) !== null && _e !== void 0 ? _e : true, (_f = json.number_of_frozen_columns) !== null && _f !== void 0 ? _f : 0, Array.isArray(json.sorting) ? Sorting.listFromJSON(json.sorting) : [new Sorting(field_1.DefaultEntityFields.UPDATED_ON, SortOrder.DESC)], Array.isArray(json.fields) ? json.fields : [], json.filter_groups ? filter_1.FilterGroup.fromJSON(json.filter_groups) : new filter_1.FilterGroup(filter_1.LogicOperator.AND), (_g = json.created_on) !== null && _g !== void 0 ? _g : 0, (_h = json.created_by) !== null && _h !== void 0 ? _h : '', (_j = json.updated_on) !== null && _j !== void 0 ? _j : 0, (_k = json.updated_by) !== null && _k !== void 0 ? _k : '', (_l = json.is_archived) !== null && _l !== void 0 ? _l : false);
        return doc;
    };
    // isValid(): boolean {
    //     return this.name.trim() !== '' && this.filter_groups.isValid();
    // }
    // Generate MongoDB query for filtering
    FilterDocument.prototype.toMongoQuery = function () {
        return this.filter_groups.toMongoQuery();
    };
    return FilterDocument;
}());
exports.FilterDocument = FilterDocument;
var SortOrder;
(function (SortOrder) {
    SortOrder["ASC"] = "asc";
    SortOrder["DESC"] = "desc";
})(SortOrder = exports.SortOrder || (exports.SortOrder = {}));
var Sorting = /** @class */ (function () {
    function Sorting(field, order) {
        this.field = field;
        this.order = order;
    }
    Sorting.fromJSON = function (json) {
        var _a;
        return new Sorting((_a = json.field) !== null && _a !== void 0 ? _a : '', json.order === SortOrder.DESC ? SortOrder.DESC : SortOrder.ASC);
    };
    Sorting.listFromJSON = function (jsonArray) {
        return Array.isArray(jsonArray)
            ? jsonArray.map(Sorting.fromJSON)
            : [];
    };
    return Sorting;
}());
exports.Sorting = Sorting;
